import i18n from "@/i18n"
export default {
  messages:{
  },
  custom: {
    totalFloorAreaValue: {
      decimal: "半角数字で入力してください"
    },
    metaDataAmountContract: {
      decimal: "半角数字（小数点以下2桁）で入力してください"
    },
    metaDataMonthSurvey: {
      decimal: "半角数字で入力してください"
    },
    metaDataMonthSurveyAmount: {
      decimal: "半角数字（小数点以下2桁）で入力してください"
    },
    inSiteWorkBudgetNumber: {
      decimal: i18n.tc('errors.valueFormatErrorDashBoard')
    },
    inSiteWorkActualNumber: {
      decimal: i18n.tc('errors.valueFormatErrorDashBoard')
    },
    outSiteWorkNumber: {
      decimal: i18n.tc('errors.valueFormatErrorDashBoard')
    },
    outSiteWorkLoadCapacityTrash: {
      decimal: i18n.tc('errors.valueFormatErrorDiaryList')
    },
    outSiteWorkTransportDistance: {
      decimal: i18n.tc('errors.valueFormatErrorDiaryList')
    },
    outSiteWorkWasteNumber: {
      decimal: i18n.tc('errors.valueFormatErrorDashBoard')
    },
    outSiteWorkWasteTransportDistance: {
      decimal: i18n.tc('errors.valueFormatErrorDashBoard')
    },
    outSiteWorkContructionSoilNumber: {
      decimal: i18n.tc('errors.valueFormatErrorDashBoard')
    },
    outSiteWorkContructionSoilLoadCapacityTrash: {
      decimal: i18n.tc('errors.valueFormatErrorDiaryList')
    },
    outSiteWorkContructionSoilTransportDistance: {
      decimal: i18n.tc('errors.valueFormatErrorDiaryList')
    },
  }
}
